/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    KijinetaTag,
    KijinetaTagFromJSON,
    KijinetaTagToJSON,
    ModelError,
    ModelErrorFromJSON,
    ModelErrorToJSON,
    PopularKeywordsResponse,
    PopularKeywordsResponseFromJSON,
    PopularKeywordsResponseToJSON,
} from '../models';

/**
 * 
 */
export class KeywordApi extends runtime.BaseAPI {

    /**
     * 人気キーワード（記事ネタタグリスト）を返すAPI
     * GET Popular keywords
     */
    async getPopularKeywordsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<PopularKeywordsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/popular_keywords.php/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PopularKeywordsResponseFromJSON(jsonValue));
    }

    /**
     * 人気キーワード（記事ネタタグリスト）を返すAPI
     * GET Popular keywords
     */
    async getPopularKeywords(initOverrides?: RequestInit): Promise<PopularKeywordsResponse> {
        const response = await this.getPopularKeywordsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 人気キーワード（記事ネタタグリスト）を返すAPI (Deprecated)
     * GET Popular keywords (Deprecated) 今後は`/popular_keywords.php/list`を使用してください
     */
    async getPopularKeywordsDeprecatedRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<KijinetaTag>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/popular_keywords`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KijinetaTagFromJSON));
    }

    /**
     * 人気キーワード（記事ネタタグリスト）を返すAPI (Deprecated)
     * GET Popular keywords (Deprecated) 今後は`/popular_keywords.php/list`を使用してください
     */
    async getPopularKeywordsDeprecated(initOverrides?: RequestInit): Promise<Array<KijinetaTag>> {
        const response = await this.getPopularKeywordsDeprecatedRaw(initOverrides);
        return await response.value();
    }

}
